import { z } from 'zod';

import { LEGAL_TABS } from '~/modules/legal';

export const zodLegalSearchSchema = z.object({
  tab: z.enum(LEGAL_TABS).default('imprint').catch('imprint'),
});

export const legalSearchDefaults = zodLegalSearchSchema.parse({});
